import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import mainBackground from '../../images/pages/main/main--background.jpg';
// eslint-disable-next-line import/no-webpack-loader-syntax
import mainBackgroundSvg from '-!raw-loader!../../images/pages/main/main--background.svg';

import '../../styles/pages/mainPage.css';
import SvgImageLoader from '../elements/SvgImageLoader';

class MainPage extends Component {

  render() {
        return (
            <article className="main-page">
                <SvgImageLoader
                  svg={mainBackgroundSvg}
                  image={mainBackground}
                  className="main-page__image"
                  alt="Bilbao Background"
                />
                <div className="main-page__container">
                    <h1 className="main-page__container-title">
                        ANDER MURIAS
                    </h1>
                    <h2 className="main-page__container-subtitle">
                        Dream Maker <span className="main-page__red">&</span> Software Developer
                    </h2>
                </div>
            </article>
        );
    }

    updateOriginOnMove(e) {
        let elementToMove = document.getElementsByClassName('main-page')[0];
        if(getComputedStyle(elementToMove).perspective !== 'none') {
            window.requestAnimationFrame(() => {
                let x = e.clientX + 20,
                    y = e.clientY + 20,
                    w = window.innerWidth,
                    h = window.innerHeight;
                elementToMove.style.perspectiveOrigin = ((x / w) * 100) + "% " + ((y / h) * 100) + "%";
            });
        }
    }

    componentDidMount() {
      window.addEventListener('mousemove', this.updateOriginOnMove);
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.updateOriginOnMove);
    }
}

const mapStateToProps = state => {
    return {
        main: state.main,
    }
};

export default withRouter(connect(mapStateToProps)(MainPage));



// WEBPACK FOOTER //
// ./src/js/pages/MainPage.js